module.exports = __webpack_public_path__ + "static/media/8OLA9.01d3282c.jpg";